import axios from 'axios'

export default {
    powertripBaseURL: "https://evnav.appstack.me/",
    powertripAPIKey: "U4VQU6Fv0AMaOlvfDNDLnibPn3CEKKZv",
    powertripAccountBaseURL:  "https://thepowertrip.co.nz/",//"https://powertrip.littlemonkey.info/",//
    getChargingStations() {
        return axios.get(this.powertripBaseURL + "station/getAllCoordinates?nophoto=1&api_key=" + this.powertripAPIKey).then(response => {
            return response.data
        });
    },
    getEVModels() {
        return axios.get(this.powertripBaseURL + "data/evmodels?api_key=" + this.powertripAPIKey).then(response => {
            return response.data
        });
    },
    getTrips(auth) {
        if (auth) {
            return axios.get(this.powertripAccountBaseURL + "station/getTrips", {
                auth: {
                    username: auth.email,
                    password: auth.password
                }
            }).then(response => {
                return response.data
            });
        } else {
            return axios.get(this.powertripBaseURL + "station/getTrips?api_key=" + this.powertripAPIKey).then(response => response);
        }
    },
    sendEmail(data) {
        return axios.post(this.powertripBaseURL + "results?api_key=" + this.powertripAPIKey, data);
    },
    newAccount(data) {
        return axios.post(this.powertripAccountBaseURL + 'register/newuser', data).then(response => {
            return response.data
        }).catch(function (error) {
            return error
        });
    },
    login(data) {
        if (data) {
            return axios.get(this.powertripAccountBaseURL + "auth/login", {
                auth: {
                    username: data.email,
                    password: data.password
                }
            }).then(response => {
                return response.data
            }).catch(function (error) {
                return error
            });
        } else {
            return axios.get(this.powertripAccountBaseURL + "auth/login").then(response => {
                return response.data
            }).catch(function (error) {
                return error
            });
        }
    },
    saveTrip(trip, auth) { //Not used at the moment
        if (!trip.fromAddress) {
            return;
        }
        var data = {}
        data.Public = 0;
        data.Name = trip.title;
        data.ID = trip.ID;
        var waypointData = [];
        var from = ["Address",{"a":trip.fromAddress.Address.Address,"latitude":trip.fromAddress.Address.geometry.coordinates[1],"longitude":trip.fromAddress.Address.geometry.coordinates[0],"hasLocation":true}];
        var to = ["Address",{"a":trip.toAddress.Address.Address,"latitude":trip.toAddress.Address.geometry.coordinates[1],"longitude":trip.toAddress.Address.geometry.coordinates[0],"hasLocation":true}];
        var via = []
        if (trip.viaAddresses && trip.viaAddresses.length > 0) {
            trip.viaAddresses.forEach(element => {
                via.push(["Address",{"a":element.Address.Address,"latitude":element.Address.Address.geometry.coordinates[1],"longitude":element.Address.Address.geometry.coordinates[0],"hasLocation":true}]);
            });
        }
        waypointData.push(from);
        if (via.length > 0) {
            via.forEach(element => {
                waypointData.push(element);
            });
        }
        waypointData.push(to);
        data.WaypointData = JSON.stringify(waypointData);
        console.log(data);
        if (auth) {
            return axios.post(this.powertripAccountBaseURL + "station/addTrip", data, {
                auth: {
                    username: auth.email,
                    password: auth.password
                }
            }).then(response => {
                return response.data
            }).catch(function (error) {
                return error
            });
        } else {
            return axios.post(this.powertripAccountBaseURL + "station/addTrip", data).then(response => {
                return response.data
            }).catch(function (error) {
                return error
            });
        }
    },
    saveUserData(data, auth) {
        if (auth) {
            return axios.post(this.powertripAccountBaseURL + "user/updateUser", data, {
                auth: {
                    username: auth.email,
                    password: auth.password
                }
            }).then(response => {
                return response.data
            }).catch(function (error) {
                return error
            });
        } else {
            return axios.post(this.powertripAccountBaseURL + "user/updateUser", data).then(response => {
                return response.data
            }).catch(function (error) {
                return error
            });
        }
    }


}